import { apiClient } from "./client";

export interface ReferralLevelInfo {
  level: number;
  minDirectInvites: number;
  /** Basis points (10000 = 100%). Display as bps/100 for percent. */
  tier1Bps: number;
  tier2Bps: number;
  tier3Bps: number;
}

export interface MyReferralInfo {
  code: string;
  inviteLink: string;
  directInvites: number;
  tier2Invites: number;
  tier3Invites: number;
  totalEarnedTokens: string;
  todayInviteCount: number;
  /** Player's current level (1–5) based on direct-invite count. */
  currentLevel: number;
  currentTier1Bps: number;
  currentTier2Bps: number;
  currentTier3Bps: number;
  /** Progress to the next level. Both null when already at max. */
  nextLevel: number | null;
  nextLevelInvitesNeeded: number | null;
  /** Full level table — UI renders the upgrade ladder. */
  levels: ReferralLevelInfo[];
  /** Whether the player can still apply an invite code (account < 24h
   * AND no existing referrer). UI hides the input otherwise. */
  canApplyCode: boolean;
  /** ISO timestamp when the 24h apply-code window closes. Null after
   * it's already past. UI uses for the countdown chip. */
  applyCodeExpiresAt: string | null;
  /** True if the player already has a locked-in referrer. */
  hasReferrer: boolean;
}

export async function fetchMyReferralInfo(): Promise<MyReferralInfo> {
  const { data } = await apiClient.get<MyReferralInfo>("/referrals/me");
  return data;
}

export interface DownlineResponse {
  direct: Array<{ refereeId: string; acceptedAt: string }>;
  tier2: Array<{ refereeId: string; viaUserId: string; acceptedAt: string }>;
}

export async function fetchDownline(limit = 50): Promise<DownlineResponse> {
  const { data } = await apiClient.get<DownlineResponse>("/referrals/downline", {
    params: { limit },
  });
  return data;
}

export async function acceptReferral(code: string): Promise<{ accepted: boolean; reason?: string }> {
  const { data } = await apiClient.post<{ accepted: boolean; reason?: string }>(
    "/referrals/accept",
    { code }
  );
  return data;
}
